import { TableDomesticPartnershipBodyVM } from 'practice/view-models/practice-edit-residence';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<
  TableDomesticPartnershipBodyVM,
  keyof TableDomesticPartnershipBodyVM
>[] = [
  {
    id: 'IdCardMunicipality',
    label: 'ID scheda Comune',
  },
  {
    id: 'codeIstat',
    label: 'Codice ISTAT Comune',
  },
  {
    id: 'idAnpr',
    label: 'ID ANPR',
  },
  {
    id: 'nameDomesticPartnership',
    label: 'Nome convivenza',
  },
  {
    id: 'address',
    label: 'Indirizzo',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
